import { makeVar } from '@apollo/client';
import { ModalKey } from 'approot/shared/modal/modal.constants';

export type GlobalModalOptions = {
  hideCloseButton?: boolean;
};

export const globalModalVar = makeVar<ModalKey>(ModalKey.NONE);
export const globalModalOptionsVar = makeVar<GlobalModalOptions>({});

export const getGlobalModal = () => globalModalVar();
export const setGlobalModal = (key: ModalKey, options?: GlobalModalOptions) => {
  globalModalVar(key);
  globalModalOptionsVar(options || {});
};
export const closeGlobalModal = () => {
  globalModalVar(ModalKey.NONE);
  globalModalOptionsVar({});
};
